export default "__VITE_ASSET__9abq5USC__"